import React from 'react';
import { ChevronRight } from 'lucide-react';
import type { OrgUnit } from '@schemas/api';

interface OrgUnitBreadcrumbsProps {
  unit: OrgUnit;
  onUnitSelect?: (unitId: string) => void;
}

export const OrgUnitBreadcrumbs: React.FC<OrgUnitBreadcrumbsProps> = ({
  unit,
  onUnitSelect,
}) => {
  const buildBreadcrumbs = (u: OrgUnit): OrgUnit[] => {
    const breadcrumbs: OrgUnit[] = [u];
    let current = u;
    while (current.parent) {
      breadcrumbs.unshift(current.parent);
      current = current.parent;
    }
    return breadcrumbs;
  };

  const breadcrumbs = buildBreadcrumbs(unit);

  return (
    <div className="flex items-center gap-1 text-sm text-gray-700">
      {breadcrumbs.map((crumb, index) => (
        <div key={crumb.id} className="flex items-center gap-1">
          {index > 0 && <ChevronRight size={14} className="text-gray-400" />}
          {onUnitSelect && index < breadcrumbs.length - 1 ? (
            <button
              onClick={() => onUnitSelect(crumb.id)}
              className="text-blue-600 hover:underline"
            >
              {crumb.name}
            </button>
          ) : (
            <span className={index === breadcrumbs.length - 1 ? 'font-semibold' : ''}>
              {crumb.name}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};
